import PropTypes from 'prop-types';

const contentDataToPropPropType = PropTypes.objectOf(PropTypes.string);

export default contentDataToPropPropType;
